import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Col, Row } from 'reactstrap';
import { AvForm, AvGroup, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import MaterialIcon from "material-icons-react";
import i18n from '../../../../i18next';

import { dispatchErrorMessage } from '../../../../actions/index';
import TimeValidationUtils from "../../../../utils/TimeValidationUtils";
import TableHour from "../../../common/TableHour";
import TableMinute from "../../../common/TableMinute";

const INITIAL_STATE = {
    id: null,
    day: null,
    exceptionDay: false,
    openHour: null,
    openMinute: null,
    closeHour: null,
    closeMinute: null,
    disabled: true,
};

class DaysOffModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            id: null,
            day: null,
            exceptionDay: false,
            openHour: null,
            openMinute: null,
            closeHour: null,
            closeMinute: null,
            disabled: true,
        };

        this.toggle = this.toggle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.resetState = this.resetState.bind(this);
        this.changeState = this.changeState.bind(this);
        // this.getValue = this.getValue.bind(this);
    }

    copyStateFromProps() {
        // Copy state from props only for exception day else state is set to the initial state
        if (this.props.selectedDate && (!this.state.stateAlreadyCopiedFromProps || this.props.selectedDate.day !== this.state.day)) {

            this.setState({
                ...this.state,
                id: this.props.selectedDate.id,
                day: this.props.selectedDate.day,
                exceptionDay: this.props.selectedDate.exceptionDay ? this.props.selectedDate.exceptionDay : false,
                openHour: this.props.selectedDate.openingTime ? this.props.selectedDate.openingTime.openHour : null,
                openMinute: this.props.selectedDate.openingTime ? this.props.selectedDate.openingTime.openMinute : null,
                closeHour: this.props.selectedDate.openingTime ? this.props.selectedDate.openingTime.closeHour : null,
                closeMinute: this.props.selectedDate.openingTime ? this.props.selectedDate.openingTime.closeMinute : null,
                disabled: this.props.selectedDate.exceptionDay ? false : true,
                stateAlreadyCopiedFromProps: true
            })

        }
    }

    resetState() {
        this.setState({
            id: null,
            day: null,
            exceptionDay: false,
            openHour: null,
            openMinute: null,
            closeHour: null,
            closeMinute: null,
            disabled: true,
        })
    }

    changeState({ target }) {
        // Toggle disable on the radio buttons
        if (target.name === 'dayOff') {

            this.setState({
                ...this.state,
                exceptionDay: false,
                disabled: true,
                openHour: '',
                openMinute: '',
                closeHour: '',
                closeMinute: ''
            });

            return;

        } else if (target.name === 'exceptionDay') {

            this.setState({
                ...this.state,
                exceptionDay: true,
                disabled: false
            });

            return;
        }

        this.setState({
            ...this.state,
            [target.name]: target.value
        });
    }

    toggle() {
        this.props.onToggle();
        this.resetState();
    }

    handleFocusOut({ target }, itemId) {
        let exceptionDays = [];
        let exceptionDayHours = {
            id: Number(target.id),
            day: this.state.day,
            exceptionDay: this.state.exceptionDay,
            openHour: this.state.openHour,
            openMinute: this.state.openMinute,
            closeHour: this.state.closeHour,
            closeMinute: this.state.closeMinute,
            disabled: this.state.disabled
        };

        exceptionDays.push(exceptionDayHours);

        let updatedOperatingHours = TimeValidationUtils.prependZeroToTimeValuesOnCondition(target, itemId, exceptionDays);

        this.setState({
            id: updatedOperatingHours[0].exceptionDay,
            day: updatedOperatingHours[0].day,
            exceptionDay: this.state.exceptionDay,
            openHour: updatedOperatingHours[0].openHour,
            openMinute: updatedOperatingHours[0].openMinute,
            closeHour: updatedOperatingHours[0].closeHour,
            closeMinute: updatedOperatingHours[0].closeMinute,
            disabled: updatedOperatingHours[0].disabled
        });
    }

    prepareStateDataForSave() {
        let openingTime = null;

        if (this.state.exceptionDay) {
            openingTime = {
                day: null,
                openHour: this.state.openHour,
                openMinute: this.state.openMinute,
                closeHour: this.state.closeHour,
                closeMinute: this.state.closeMinute,
                maximumNumberOfOrders: null
            }
        }

        let stateData = {
            day: this.state.day,
            exceptionDay: this.state.exceptionDay,
            openingTime: openingTime
        };
        // Remove id and disabled from the state object and create saveRequest object
        let saveRequest = Object.keys(stateData).reduce((object, key) => {
            if (key !== 'id' && key !== 'disabled') {
                object[key] = stateData[key]
            }
            return object
        }, {});

        return saveRequest;
    }

    hourMinuteValidation() {
        let valid = true;
        let saveRequest = this.prepareStateDataForSave();

        if (saveRequest.openingTime.openHour === '' || saveRequest.openingTime.openHour === null) {
            //error
            this.props.dispatchErrorMessage(i18n.t('actions:openingHoursActions.enterOpeningTime'));
            valid = false;
        }

        if (saveRequest.openingTime.openMinute === '' || saveRequest.openingTime.openMinute === null) {
            //error
            this.props.dispatchErrorMessage(i18n.t('actions:openingHoursActions.enterOpeningTime'));
            valid = false;

        }

        if (saveRequest.openingTime.closeHour === '' || saveRequest.openingTime.closeHour === null) {
            //error
            this.props.dispatchErrorMessage(i18n.t('actions:openingHoursActions.enterClosingTime'));
            valid = false;
        }

        if (saveRequest.openingTime.closeMinute === '' || saveRequest.openingTime.closeMinute === null) {
            //error
            this.props.dispatchErrorMessage(i18n.t('actions:openingHoursActions.enterClosingTime'));
            valid = false;
        }

        return valid;
    }

    handleSubmit() {
        if (this.state.exceptionDay) {
            let valid = this.hourMinuteValidation();

            if (!valid) {
                return;
            }
        }
        // Add selectedDay from props to state and then in the callback create
        // the request object for the parent component and pass it to the onSave method
        this.setState({ ...this.state, day: this.props.selectedDay }, () => {

            let saveRequest = this.prepareStateDataForSave();

            this.props.onSave(saveRequest);
            this.toggle();
        });
    }

    handleDelete() {
        this.setState({ ...this.state, day: this.props.selectedDay }, () => {
            this.props.onDelete(this.state);
            this.toggle();
        });
    }

    getValue(value) {
        console.log(value, 'VALUE')
        if (value === 0 || value === '0') {
            return '00';
        }

        return value || '';
    }

    renderOpeningHours() {
        const { inputContainer, inputStyle } = style;
        let openHourId = Number(new Date());
        let openMinuteId = Number(new Date());

        return (
            <Row>
                <Col xs={12}>
                    <Label>{i18n.t('screens:daysOffModal.openingHoursLabel')}</Label>
                </Col>
                <AvGroup className='col-sm-6' style={inputContainer}>
                    <TableHour
                        type="text"
                        name="openHour"
                        placeholder="hh"
                        disabled={this.state.disabled}
                        customStyle={inputStyle}
                        id={openHourId}
                        value={this.state.openHour}
                        handleStateChange={this.changeState.bind(this)}
                        handleBlur={(event) => { this.handleFocusOut(event, openHourId) }}
                        step={1}
                    />
                </AvGroup>
                <AvGroup className='col-sm-6' style={inputContainer}>
                    <TableMinute
                        type="text"
                        name="openMinute"
                        placeholder="mm"
                        disabled={this.state.disabled}
                        customStyle={inputStyle}
                        id={openMinuteId}
                        value={this.getValue(this.state.openMinute)}
                        handleStateChange={this.changeState.bind(this)}
                        handleBlur={(event) => { this.handleFocusOut(event, openMinuteId) }}
                        step={1}
                    />
                </AvGroup>
            </Row>
        );
    }

    renderClosingHours() {
        const { inputContainer, inputStyle } = style;
        let closeHourId = Number(new Date());
        let closeMinuteId = Number(new Date());

        return (
            <Row>
                <Col xs={12}>
                    <Label>{i18n.t('screens:daysOffModal.closingHoursLabel')}</Label>
                </Col>
                <AvGroup className='col-sm-6' style={inputContainer}>
                    <TableHour
                        type="text"
                        name="closeHour"
                        placeholder="hh"
                        disabled={this.state.disabled}
                        customStyle={inputStyle}
                        id={closeHourId}
                        value={this.state.closeHour}
                        handleStateChange={this.changeState.bind(this)}
                        handleBlur={(event) => { this.handleFocusOut(event, closeHourId) }}
                        step={1}
                    />
                </AvGroup>
                <AvGroup className='col-sm-6' style={inputContainer}>
                    <TableMinute
                        type="text"
                        name="closeMinute"
                        placeholder="mm"
                        disabled={this.state.disabled}
                        customStyle={inputStyle}
                        id={closeMinuteId}
                        value={this.getValue(this.state.closeMinute)}
                        handleStateChange={this.changeState.bind(this)}
                        handleBlur={(event) => { this.handleFocusOut(event, closeMinuteId) }}
                        step={1}
                    />
                </AvGroup>
            </Row>
        );
    }

    renderFindManagerForm() {
        const { modalContentContainer } = style;
        let defaultValues = null;

        this.state.exceptionDay ? defaultValues = { date_type: 'exceptionDay' } : defaultValues = { date_type: 'dayOff' }

        return (
            <AvForm className="modalForm" onValidSubmit={this.handleSubmit} model={defaultValues}>
                <ModalHeader className="modalHeader" toggle={this.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                    <div style={modalContentContainer}>
                        <Col xs={12}>
                            <Label>{i18n.t('screens:daysOffModal.typeOfDateLabel')}</Label>
                            <AvRadioGroup model={defaultValues} inline name="date_type" id="date_type" required>
                                <AvRadio label={i18n.t('screens:daysOffModal.dayOff')} name="dayOff" value="dayOff" onChange={this.changeState} />
                                <AvRadio label={i18n.t('screens:daysOffModal.exceptionDay')} name="exceptionDay" value="exceptionDay" onChange={this.changeState} />
                            </AvRadioGroup>
                        </Col>

                        <Col xs={12}>
                            {this.renderOpeningHours()}
                            {this.renderClosingHours()}
                        </Col>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" >
                        <MaterialIcon icon="done" color="#fff" size={18} />{i18n.t('common:buttons.apply')}
                    </Button>
                    <Button outline color="primary" onClick={this.handleDelete.bind(this)}>
                        <MaterialIcon icon="delete" color="#0288D1" size={18} />{i18n.t('common:buttons.delete')}
                    </Button>
                </ModalFooter>
            </AvForm>
        );
    }

    render() {

        if (this.props.selectedDate) {
            this.copyStateFromProps();
        }

        let form = this.renderFindManagerForm();

        return (
            <div>
                <Modal isOpen={this.props.isOpen} toggle={this.toggle}>
                    {form}
                </Modal>
            </div>
        );
    }
}

export default connect(null, { dispatchErrorMessage })(DaysOffModal);

const style = {
    inputContainer: {
        height: 80,
        display: 'flex'
    },
    inputStyle: {
        width: 173
    },
    modalContentContainer: {
        backgroundColor: '#f8f8f8',
        paddingTop: 10,
        paddingBottom: 10,
        border: '1px solid #E9ECEF'
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/DaysOffModal.js